import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IContactItem } from '../../../store/models/contact.model';
import { EMenuButtonItemType, IMenuButtonProperties } from '../../../store/models/menu-button.model';

@Component({
  selector: 'app-contacts-listing-mobile-row',
  templateUrl: './contacts-listing-mobile-row.component.html',
  styleUrls: ['./contacts-listing-mobile-row.component.scss'],
})
export class ContactsListingMobileRowComponent implements OnInit {

  @Input() item: IContactItem;

  @Output() vip: EventEmitter<IContactItem> = new EventEmitter();
  @Output() activity: EventEmitter<IContactItem> = new EventEmitter();

  menuItems: IMenuButtonProperties = {
    items: [],
  };

  constructor() {
  }

  get contactName() {
    return `${this.item.contact_firstname || ''} ${this.item.contact_lastname || ''}`;
  }

  ngOnInit(): void {
    this.menuItems.items.push({
      label: 'Edit',
      type: EMenuButtonItemType.LINK,
      route: ['/user_contacts', this.item.contact_id, 'edit'],
    });
    this.menuItems.items.push({
      label: `VIP ${this.item.contact_vip ? 'Off' : 'On'}`,
      type: EMenuButtonItemType.BUTTON,
      onClick: (target: IContactItem) => this.vip.emit(target),
    });
    this.menuItems.items.push({
      label: 'Activity',
      type: EMenuButtonItemType.BUTTON,
      onClick: (target: IContactItem) => this.activity.emit(target),
    });
  }

}
